<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="增加共有人"
      fontSize="0.32rem"
    />
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="bor_b">
        <van-field
          readonly
          name="type"
          :value="$route.query.index === 'main' ? '买受人' : '共有人'"
          label="类型"
        />
        <van-field
          v-show="false"
          name="traderType"
          value="2"
          label="类型"
        />
        <van-field
          :disabled="$route.query.index === 'main'"
          v-model="traderName"
          name="traderName"
          label="姓名"
          placeholder="请输入姓名"
          maxlength="10"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          :disabled="$route.query.index === 'main'"
          v-model="idNumber"
          name="idNumber"
          label="身份证号"
          maxlength="18"
          placeholder="请输入身份证号"
          :rules="[{ validator: isCard, message: '请填写正确的身份证号' }]"
        />
        <van-field
          :disabled="$route.query.index === 'main'"
          v-model="traderPhone"
          name="traderPhone"
          label="联系电话"
          maxlength="11"
          type="number"
          placeholder="请输入联系电话"
          :rules="[{ validator: isPhone, message: '请填写正确的联系电话' }]"
        />
        <van-field
          v-model="traderAddress"
          name="traderAddress"
          label="联系地址"
          placeholder="请输入联系地址"
          :rules="[{ required: true, message: '请填写联系地址' }]"
        />
      </div>
      <div v-if="$route.query.current === '3' && $route.query.index !== 'main'">
        <van-field
          v-model="share"
          name="share"
          type="number"
          label="份额"
          maxlength="2"
          placeholder="请输入份额"
          :rules="[{ validator: isFen, message: '请填写份额' }]"
        />
      </div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          保存
        </van-button>
      </div>
    </van-form>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      traderName: '',
      idNumber: '',
      traderPhone: '',
      traderAddress: '',
      share: '',
      type: null
    };
  },
  components: {
    topHeader
  },
  mounted() {
    this.type = this.$route.query.current * 1 - 1;
    if(this.$route.query.index) {
      if(this.$route.query.index == 'main') {
        this.traderName = JSON.parse(sessionStorage.getItem('info')).purchaser
        this.idNumber = JSON.parse(sessionStorage.getItem('info')).purPassNo
        this.traderPhone = JSON.parse(sessionStorage.getItem('info')).purPhone
        this.traderAddress = JSON.parse(sessionStorage.getItem('info')).purAddress
      } else {
        const list = JSON.parse(sessionStorage.getItem('gyrList' + this.$route.query.current));
        this.traderName = list[this.$route.query.index].traderName
        this.idNumber = list[this.$route.query.index].idNumber
        this.traderPhone = list[this.$route.query.index].traderPhone
        this.traderAddress = list[this.$route.query.index].traderAddress
        this.share = list[this.$route.query.index].share
      }
    }
  },
  methods: {
    onSubmit(values) {
      if(this.$route.query.index == 'main') {
        // 买受人信息
        const obj = JSON.parse(sessionStorage.getItem('info'));
        obj.purAddress = this.traderAddress;
        sessionStorage.setItem('info', JSON.stringify(obj));
      } else {
        // 共有人信息
        const list = sessionStorage.getItem('gyrList' + this.$route.query.current) ? JSON.parse(sessionStorage.getItem('gyrList' + this.$route.query.current)) : [];
        if(this.$route.query.index) {
          list[this.$route.query.index] = values;
        } else {
          list.push(values);
        }
        // 判断类型是否是按份所有
        if(this.$route.query.current == 3) {
          if(this.share > 100 || this.share < 1) {
            this.$toast('份额不得大于100或小于1');
            return
          }
          let extre = 0;
          list.forEach(item => {
            extre += item.share * 1
          });
          if(extre >= 100) {
            this.$toast('所有共有人份额不得超过99');
            return
          }
        }
        sessionStorage.setItem('gyrList' + this.$route.query.current, JSON.stringify(list))
      }
      setTimeout(() => {
        this.$router.go(-1)
      }, 50);
    },
    isCard(str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(str);
    },
    isPhone(str) {
      return /^1[3456789]\d{9}$/.test(str);
    },
    isFen(str) {
      if(this.$route.query.current === '3' && !this.share) {
        return false
      } else {
        return true
      }
    }
  },
};
</script>
<style lang="less" scoped>
.bg_gray{
  background-color: #f5f5f5;
  min-height: 100vh;
}
h3{
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}
.form_con{
  padding: 0.3rem 0rem;
}
/deep/
.van-uploader{
  margin-right: -8px;
}
.pad_b{
  padding-bottom: 1.68rem;
}
.btn_con{
  padding: 0.4rem 0;
  left: 0;
  right: 0;
  /deep/
  .van-button{
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}
</style>